import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
	modalTitle: {
		backgroundColor: "#ced2cc",
		color: "#495057",
		textAlign: "center",
	},
	extensionStyle: {
		border: "1px solid green",
		borderRadius: 8,
		width: "100px",
		height: "120px",
		justifyContent: "center",
		alignItems: "center",
		marginLeft: "auto",
	},
	card: {
		width: 200,
		height: "auto",
		minHeight: "50px",
		margin: "5px 0",
		backgroundColor: "#f2f2f2",
		borderRadius: 8,
		padding: 10,
		boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
		position: "relative",
		overflow: "hidden",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	label: {
		fontSize: 12,
		position: "absolute",
		top: 2,
		left: 10,
		color: "#666",
	},
	value: {
		fontSize: 18,
		position: "absolute",
		bottom: 2,
		left: 10,
		color: "#333",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		maxWidth: "94%",
	},
}));

export const DialogHeader = () => {
	const classes = useStyles();

	const {
		state: { rowSelectedInDrawing },
	} = useWorkOrderModalsContext();
	return (
		<Grid
			container
			style={{ alignItems: "flex-start", padding: "0 20px 10px 10px" }}
		>
			<Grid container item md={12} xs={12}>
				<Grid
					container
					item
					md={2}
					xs={12}
					style={{ margin: "5px 0 10px -8px" }}
				></Grid>
				<Grid container item md={10} xs={12} style={{ margin: "5px 0 10px" }}>
					<Typography>
						<b>{`${rowSelectedInDrawing?.Title}`}</b>
					</Typography>
				</Grid>
			</Grid>
			<Paper
				elevation={0}
				className={classes.card}
				style={{
					backgroundColor: "#ccebff",
					width: 175,
					margin: "5px 15px 0 10px",
				}}
			>
				<Typography
					variant="h6"
					className={classes.value}
					style={{ fontSize: 25, width: "100%", height: "100%", margin: 0 }}
				>
					<Grid
						container
						style={{
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<b style={{ height: "100%", lineHeight: 2.2, marginRight: 15 }}>
							{rowSelectedInDrawing?.DocumentName}
						</b>
					</Grid>
				</Typography>
			</Paper>
			{rowSelectedInDrawing?.IsObsolete && (
				<Paper
					elevation={0}
					className={classes.card}
					style={{
						backgroundColor: "#EB9090D9",
						width: 175,
						maxHeight: "40px",
						borderRadius: 8,
						padding: 10,
						boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
						overflow: "hidden",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						position: "absolute",
						top: 114,
						left: 20,
					}}
				>
					<Typography variant="h6">
						<b> {rowSelectedInDrawing?.IsObsolete && "OBSOLETE"}</b>
					</Typography>
				</Paper>
			)}
			<Grid
				container
				item
				md={2}
				xs={2}
				style={{ flexWrap: "nowrap", flexDirection: "column" }}
			>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						Version
					</Typography>
					<Typography variant="h6" className={classes.value}>
						<b>{rowSelectedInDrawing?.Version}</b>
					</Typography>
				</Paper>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						User
					</Typography>
					<Typography
						variant="h6"
						className={classes.value}
						style={{ overflow: "hidden" }}
					>
						<b> {rowSelectedInDrawing?.UserName}</b>
					</Typography>
				</Paper>
			</Grid>

			<Grid
				container
				item
				md={3}
				xs={2}
				style={{ flexWrap: "nowrap", flexDirection: "column" }}
			>
				{rowSelectedInDrawing?.UploadTimestamp && (
					<Paper
						elevation={0}
						className={classes.card}
						style={{ width: "300px" }}
					>
						<Typography variant="subtitle2" className={classes.label}>
							Uploaded
						</Typography>
						<Typography
							variant="h6"
							className={classes.value}
							style={{ overflow: "hidden" }}
						>
							<b>
								{" "}
								{moment(
									rowSelectedInDrawing?.UploadTimestamp,
									"YYYY-MM-DDTHH:mm:ss.SSS",
								).format("MM/DD/YYYY HH:mm:ss")}
							</b>
						</Typography>
					</Paper>
				)}
				{rowSelectedInDrawing?.UpdatingUserName &&
					rowSelectedInDrawing?.UpdatingFlag && (
						<Grid
							container
							item
							md={2}
							xs={2}
							style={{ flexWrap: "nowrap", flexDirection: "column" }}
						>
							{rowSelectedInDrawing?.UpdatingUserName &&
								rowSelectedInDrawing?.UpdatingFlag && (
									<Paper
										elevation={0}
										className={classes.card}
										style={{ backgroundColor: "#d8050f43", width: "300px" }}
									>
										<Typography variant="subtitle2" className={classes.label}>
											Flagged by
										</Typography>
										<Typography variant="h6" className={classes.value}>
											<b> {rowSelectedInDrawing?.UpdatingUserName}</b> on{" "}
											<b>
												{moment(
													rowSelectedInDrawing?.UpdatingTimestamp,
													"YYYY-MM-DDTHH:mm:ss.SSS",
												).format("MM/DD/YYYY HH:mm:ss")}
											</b>
										</Typography>
									</Paper>
								)}
						</Grid>
					)}
			</Grid>

			<Grid
				container
				item
				md={2}
				xs={2}
				style={{ flexWrap: "nowrap", flexDirection: "column" }}
			>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						Vendor Name
					</Typography>
					<Typography
						variant="h6"
						className={classes.value}
						style={{ overflow: "hidden" }}
					>
						<b> {rowSelectedInDrawing?.VendorName}</b>
					</Typography>
				</Paper>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						Vendor Document
					</Typography>
					<Typography
						variant="h6"
						className={classes.value}
						style={{ overflow: "hidden" }}
					>
						<b> {rowSelectedInDrawing?.VendorDocument}</b>
					</Typography>
				</Paper>
			</Grid>

			<Grid
				container
				item
				md={2}
				xs={2}
				style={{ flexWrap: "nowrap", flexDirection: "column" }}
			>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						Vendor Version
					</Typography>
					<Typography
						variant="h6"
						className={classes.value}
						style={{ overflow: "hidden" }}
					>
						<b> {rowSelectedInDrawing?.VendorVersion}</b>
					</Typography>
				</Paper>
				<Paper elevation={0} className={classes.card}>
					<Typography variant="subtitle2" className={classes.label}>
						Vendor Creation
					</Typography>
					<Typography
						variant="h6"
						className={classes.value}
						style={{ overflow: "hidden" }}
					>
						<b>
							{" "}
							{rowSelectedInDrawing?.VendorDatetime
								? moment(
										rowSelectedInDrawing?.VendorDatetime,
										"MMM D YYYY h:mmA",
									).format("MM/DD/YYYY")
								: ""}
						</b>
					</Typography>
				</Paper>
			</Grid>

			<Grid
				container
				item
				md={1}
				xs={2}
				style={{ flexWrap: "nowrap", marginLeft: "auto" }}
			>
				<Grid
					container
					className={classes.extensionStyle}
					style={{
						backgroundColor:
							rowSelectedInDrawing?.Extension === "TIF"
								? "#F8CECC"
								: rowSelectedInDrawing?.Extension === "DWG"
									? "#FFF2CC"
									: rowSelectedInDrawing?.Extension === "CAL"
										? "#D5E8D4"
										: rowSelectedInDrawing?.Extension === "PDF"
											? "#E1D5E7"
											: "#DAE8FC",
						border:
							rowSelectedInDrawing?.Extension === "TIF"
								? "1px solid rgba(255, 0, 0, 0.5)"
								: rowSelectedInDrawing?.Extension === "DWG"
									? "1px solid rgba(255, 255, 0, 0.5)"
									: rowSelectedInDrawing?.Extension === "CAL"
										? "1px solid rgba(0, 128, 0, 0.5)"
										: rowSelectedInDrawing?.Extension === "PDF"
											? "1px solid rgba(128, 0, 128, 0.5)"
											: "1px solid rgba(0, 0, 255, 0.5)",
					}}
				>
					<Grid item md={12} xs={12} style={{ textAlign: "center" }}>
						{" "}
						<b>{rowSelectedInDrawing?.Extension} </b>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
